// Modules
import React from "react";
import Modal from "../../interface/Modals";
import OTPInput from "../../interface/InputFields/otpInput";


// Pay Bill
function CompanyRegistrationOTPModal({
  handleClose,
  loader,
  handleModalSubmit,
  handleOnclick,
  handleModalSubmit2,
  handleOnclick2,
  message,
  OTP,
  setOTP,
}) {
  return (
    <Modal
      Title={`Reset Password`}
      handleModalSubmit={handleModalSubmit}
      handleModalSubmit2={handleModalSubmit2}
      handleOnclick={handleOnclick}
      handleResentCashPin={handleOnclick2}
      handleClose={handleClose}
      loader={loader}
      ButtonText={`Verify`}
      ButtonText2={`Resend Prompt`}
      Content={
        <div className="pt-8">
          <div className="text-center px-5 py-8 bg-gradient-to-r from-brand to-orange_500 text-negative text-body_base font-bold rounded-lg">
          {message}
          </div>
          <div className="pt-7 w-full">
           <OTPInput 
            OTP={OTP}
            setOTP={setOTP}
            OTPFieldsNumber={5}
           />
          </div>
        </div>
      }
    />
  );
}

// Export
export default CompanyRegistrationOTPModal;
